import { Injectable } from '@angular/core';

@Injectable()
export class ConstantsService {
  constructor() {}

  public static URL = {
    // Local Environment

    // APP: 'http://localhost:4200/',
    // API: 'https://localhost:44388/',

    // UAT
    //  APP: 'https://arahseuatapp.azurewebsites.net/',
    // API: 'https://arahseuatapi.azurewebsites.net/',

    // PROD
    APP: 'https://hse.arapetroleum.com/',
    API: 'https://arahseproductionapi.azurewebsites.net/',

    HOMEPAGE: 'home',
    MasterScreen: 'masterscreen',
    MAP_KEY: 'AIzaSyC8FtKriI8gsCKM9B5bDjDkHWNzGCOwjqc',
  };

  public static ADALCONFIG = {
    ANONYMOUS_ENDPOINTS: [
      'api/authentication/getdomaindetails',
      'api/authentication/authenticatecontractorlogin',
      'api/authentication/authenticateemployeelogin',
      'api/common/send/forgetpassword',
      'api/common/get/getAppVersion',
      'api/common/get/userbyemailorid',
      'api/pob/add/confirmPassRequest',
      'api/pob/add/addPobMembers',
    ],
  };
  public static ADALCONFIGDETAILS = {
    //QA-Dev
    // Tenant: 'common',
    // Instance: 'https://login.microsoftonline.com/',
    // ClientId: '7f03207f-bce0-4077-9f99-052b19f4027a',

    // //Aapna UAT
    // Tenant:'common',
    // Instance:'https://login.microsoftonline.com/',
    // ClientId:'f4c4a83d-f84e-4216-bc04-c8f9c58fa3ec',

    //UAT
    // Tenant: 'common',
    // Instance: 'https://login.microsoftonline.com/',
    // ClientId: '2a42d1a9-dab5-495e-a36d-cf9d31514e4a',

    ////PROD
    Tenant: 'common',
    Instance: 'https://login.microsoftonline.com/',
    ClientId: 'b3a851b0-f3a5-4107-9f10-8ab98a9f49ca',
  };
  public static APIURL = {
    Authentication: {
      Ping: 'api/authentication/ping',
      GetDomainDetails: 'api/authentication/getdomaindetails',
      AuthenticateContractor: 'api/authentication/authenticatecontractorlogin',
      AuthenticateEmployee: 'api/authentication/authenticateemployeelogin',
      GetCurrentAppVersion: '/api/authentication/getappversion',
      SaveLoggedInUserDetails:
        'api/common/configuration/saveLoggedInUserDetails',
      ConfirmPassRequest: 'api/pob/add/confirmPassRequest',
      AddMembers: 'api/pob/add/addPobMembers',
      GetDescriptionListData: 'api/common/get/descriptionListData',
      GetProfileImage: '/api/authentication/getProfileImage',
    },
    Common: {
      ForgetPassword: 'api/common/send/forgetpassword',
      GetUserByEmailOrId: 'api/common/get/userbyemailorid',
      GetStatusListByProcessName: 'api/common/get/statuslistbyprocessname',
      ChangePassword: 'api/common/configuration/changeUserPassword',
      GetUsersOnSearch: 'api/common/get/usersOnSearch',
      GetHseAdvisorDetailsByCompanyId:
        'api/common/get/hseadvisormodelbycompanyid',
      GetCompanyDetails: 'api/hse/configuration/getcompanydetails',
      SaveTempAuditData: 'api/common/configuration/savetempauditdata',
      GetPermissionDetailsForUser: 'api/common/get/GetUserPermissionDetails',
      GetTempAuditData: 'api/common/configuration/gettempauditdata',
      SaveDocumentsToDMS: 'api/common/common/uploadDocumentToDocumentHeap',
      GetUserIndependentPermissions:
        'api/common/GetUnitIndependentPermissionsForUser',
      GetUserIndependentPermissionsByUserEmail:
        'api/common/GetUserIndependentPermissionsByUserEmail',
      GetUsersByUsageType: 'api/common/GetUsersByUsageType',
      GetCategoryData: 'api/hse/observationCard/getSpecificationData',
      ModifyRecord: 'api/common/ModifyRecord',
      SaveSequenceDetails: 'api/common/SaveSequenceDetails',
      GetRecordDetails: 'api/common/GetRecordDetails',
      GetFAQDetails: 'api/common/get/GetFAQDetails',
      GetReportLog: 'api/common/get/GetReportLog',
      RestoreRecord: 'api/common/RestoreRecord',
      ApproveRecord: 'api/risk/ApproveRecord',
      GetRiskApproverLog: 'api/common/get/GetRiskApproverLog',
    },
  };

  // Add common constants
  public static commonConstants = {
    opensideBar: 'opensidebar',
    loggedInUser: 'loggedInUser',
    opensubmenu: 'opensubmenu',
  };

  public static authenticationType = {
    Contractor: 'Contractor',
    Employee: 'Employee',
  };

  // Alert Types
  public static Success = 'Success';
  public static Error = 'Error';
  public static Warning = 'Warning';
  public static Confirm = 'Confirm';

  // Role details
  public static Roles = {
    AppAdminRole: 'AppAdmin',
    HSEAdvisor: 'HSEAdvisor',
    HSEMember: 'HSEMember',
    CaseOwner: 'CaseOwner',
    BackOffice: 'BackOffice',
  };

  public static ContractorLoginResponse = 'ContractorLoginResponse';
  public static EmployeeLoginResponse = 'EmployeeLoginResponse';
  public static ValidateEmployeeLoginResponse = 'ValidateEmployeeLoginResponse';
  public static LoggedInUserType = 'LoggedInUserType';

  public static CurrentUserURL = 'CurrentUserURL';
  public static NavigationStatus = 'Navigated';

  // Declartion of company name
  public static CompanyName = {
    B44: 'B44',
    QAMP: 'QAMP',
  };

  // Set Process Name
  public static ProcessName = {
    Observation: 'Observation',
    TempObservation: 'TempObservation',
    Incident: 'Incident',
  };

  // Set Active / InActive for fields
  public static ActiveInactiveStatus = {
    Active: 'Active',
    Inactive: 'Inactive',
  };

  // Collection Of Role
  public static UserRole = {
    HSEAdvisor: 'HSEAdvisor',
  };

  // Comment section constants, used for action comment configuration
  public static AcitonCommentConstants = {
    HSEAdviserToActionOwner:
      'HSE Adviser added action and assigned it to Action owner :',
    HSEAdviserToActionParty:
      'HSE Adviser added action and assigned it to Action Party :',
    HSEAdviserToActionVerifier:
      'HSE Adviser added action and assigned it to Action Verifier :',
    HSEAdviserCloseAction: 'HSE Adviser has closed action.',
    HSEAdviserChangeActionOwner:
      'HSE Adviser has changed the Action owner to :',
    HSEAdviserChangeActionParty:
      'HSE Adviser has changed the Action party to :',
    HSEAdviserChangeActionVerifier:
      'HSE Adviser has changed the Action verifier to :',
    ActionOwner: 'Action owner has updated the action details. Action owner :',
    ActionParty: 'Action party has updated the action details. Action party :',
    ActionVerifier:
      'Action verifier has updated the action details. Action verifier :',
    StatusFrom: 'Action status changed from :',
    StatusTo: 'Action status changed to :',
  };

  // Set List of Status
  public static Status = {
    Deleted: 'Deleted',
    Acknowledged: 'Acknowledged',
    Cancelled: 'Cancelled',
    Closed: 'Closed',
  };

  // Set Module Name
  public static Module = {
    Observation: 'observation',
  };

  /* Modules Used for Permission Matrix*/
  public static PermissionMatrixModules = {
    ActionTracker: 1,
    Incident: 2,
    Risk: 3,
    Observation: 4,
    POB: 5,
    System: 6,
    Task: 7,
    Inspection: 8,
    PTW: 9,
    TNC: 10,
    DL: 11,
    PD: 12,
  };
  /* */

  /* Modules Used for Permission Matrix*/
  public static RiskManagementTool = {
    MOC: 1,
    JSA: 2,
    HEMP: 8,
    HAZID: 3,
    HAZOP: 6,
  };

  public static MOCChangeCategory = {
    Hardware: '1',
    Procedural: '2',
    Organizational: '3',
    ProcessControl: '4',
    ProcessCondition: '5',
    Other: '6',
  };
  /* Modules Used for Permission Matrix*/
  public static RiskManagementToolName = {
    MOC: 'MOC',
    JSA: 'JSA',
    HEMP: 'HEMP',
    HAZID: 'HAZID',
    HAZOP: 'HAZOP',
  };
  /* */
  /* Modules Used for Permission Matrix*/
  public static RiskManagementToolRedirection = {
    MOC: 'raise-risk-moc',
    JSA: 'raise-risk-jsa',
    HEMP: 'raise-risk-hemp',
    HAZID: 'raise-risk-hazop',
    HAZOP: 'raise-risk-hazid',
  };
  /* */
}
